import type { SVGProps } from "react";
const SvgHome04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M8.333 15h3.334"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M1.96 11.011c-.295-1.914-.442-2.871-.08-3.72.362-.848 1.165-1.429 2.77-2.59l1.2-.868C7.85 2.39 8.848 1.667 10 1.667c1.152 0 2.151.722 4.15 2.166l1.199.868c1.606 1.161 2.409 1.742 2.77 2.59.363.849.216 1.806-.078 3.72l-.251 1.633c-.417 2.713-.626 4.07-1.6 4.88-.972.81-2.395.81-5.241.81H9.051c-2.846 0-4.269 0-5.242-.81s-1.182-2.167-1.599-4.88z"
    />
  </svg>
);
export default SvgHome04;
